import { ErrorPage } from '../components/ErrorPage'
import { Layout } from '../components/Layout'
import { Loader } from '../components/Loader'
import { APP_STATUS_ERROR } from '../constants/common'

export function getAppLayoutRoute({ children, getMenuItems, path }) {
  return {
    HydrateFallback: Loader,
    children,
    element: <Layout getMenuItems={getMenuItems} />,
    errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
    path,
  }
}
